import React from 'react';
import { renderToString } from 'react-dom/server';
import { fmt, addDot, addStr } from './index';
import TooltipMapa from '../components/TooltipMapa';
import Cargo from '../components/svg/Cargo';

const tooltipMapa = (stateRef, isDesktop, setTooltipProps) => {
  return {
    confine: true,
    show: true,
    // showContent: false,
    padding: 0,
    extraCssText: !isDesktop ? 'visibility:hidden' : '',
    backgroundColor: 'transparent',
    position: (point, params, dom, rect, size) => {
      setTooltipProps(s => ({
        ...s,
        // gets de central point of the region
        // prettier-ignore
        position: { x: rect.x + (rect.width / 2), y: rect.y + (rect.height / 2) },
        params: { data: params.data, name: params.name },
      }));
      return [0, 0];
    },
    formatter: function(params) {
      return '';
    },
  };
};

const formatterCalor = (params, nomenclator, tooltip, eleccion) => {
  const name = nomenclator.ambitos['10'].find(e => e.c === params.name)?.n;
  const dato = params.data.value;
  const sinInfo = params.data?.data?.sinInfo;
  const esCapital = dato === 'capital' || params.componentType === 'markPoint';

  return renderToString(
    <TooltipMapa>
      <div
        style={{
          textTransform: 'uppercase',
          fontWeight: esCapital ? 'bold' : '900',
          marginBottom: !esCapital ? '0.1em' : '',
        }}
      >
        {name}
      </div>
      {esCapital ? (
        ``
      ) : (
        <div>
          {// eslint-disable-next-line no-nested-ternary
          isNaN(dato)
            ? dato
            : sinInfo
            ? 'Sin información'
            : tooltip +
              (dato === 100
                ? dato.toString()
                : dato.toFixed(2).replace(/\./g, ',')) +
              '%'}
        </div>
      )}
    </TooltipMapa>
  );
};

const formatterGanadores = (params, nomenclator, eleccion) => {
  const ambito =
    nomenclator.ambitos[eleccion].find(e => e.c === params.name)?.n ||
    nomenclator.ambitos['10'].find(e => e.c === params.name)?.n ||
    'Colombia';
  const esCapital =
    params.data.value === 'capital' || params.componentType === 'markPoint';
  let partido, votos, showValue, hayInfo, hayEmpate, noSeCelebra;

  if (typeof params.data.value === 'object') {
    partido = nomenclator.partidos[Number(params.data.value.codpar) - 1].nombre;
    votos = params.data.value.vot;
    showValue = params.data.value.showValue;
    hayEmpate = params.data.value.hayEmpate;
    hayInfo = params.data.value.mesas !== '0';
  } else {
    noSeCelebra = params.data.value;
  }

  return renderToString(
    <TooltipMapa>
      <div
        style={{
          textTransform: 'uppercase',
          fontWeight: esCapital ? 'bold' : '900',
        }}
      >
        {ambito}
      </div>
      {// eslint-disable-next-line no-nested-ternary
      esCapital ? (
        ``
      ) : noSeCelebra ? (
        <div>{noSeCelebra}</div>
      ) : !hayInfo ? (
        <div>Sin información</div>
      ) : votos === 0 && !hayEmpate ? (
        ''
      ) : (
        <div
          style={{
            overflowX: 'hidden',
            textOverflow: 'ellipsis',
            textTransform: 'uppercase',
          }}
        >
          <span>{hayEmpate ? 'Empate' : partido}</span>
        </div>
      )}
      {window.iniData.showCurules ? (
        <div>
          {showValue} <Cargo /> ({addDot(votos)}) votos
        </div>
      ) : (
        <div>
          {showValue} ({addDot(votos)}) votos
        </div>
      )}
    </TooltipMapa>
  );
};

const formatterNoSeCelebra = (params, nomenclator, mapFeatures) => {
  const feature =
    mapFeatures &&
    mapFeatures.features.find(x => x.properties.name === params.name);
  const ambito =
    (feature && feature?.properties?.NOMBRE) ||
    feature?.properties?.nombre ||
    nomenclator.ambitos[10].find(a => a.c === feature?.properties?.name)?.n ||
    '';
  const text = params.seriesName === '88' ? 'No aplica' : 'No se celebra';

  return `
        <div style="max-width: 25rem; color: #333; padding: 0.5rem 1rem; font-size: 1.3rem; box-shadow:1px 1px 7px 0px rgba(0, 0, 0, 0.3); border-radius:2px; font-family: 'Raleway', 'Open Sans', 'Calibri', 'Georgia', 'Helvetica', 'sans-serif';">
        <div style='text-transform: uppercase; font-weight: bold;'>${ambito}</div>
        ${params.seriesName !== 'citreps' ? `<div>${text}</div>` : ''}
        </div>`;
};

const formatterSectores = (params, nomenclator) => {
  const ambito = nomenclator.ambitos[1].find(e => e.c === params.name).n;
  const esCapital =
    params.data.value === 'capital' || params.componentType === 'markPoint';
  let camara, votos, pvotos, hayInfo, noSeCelebra, hayEmpate, hayGanador;

  if (typeof params.data.info === 'object') {
    camara = nomenclator.sectores[Number(params.data.info.codCamara)].nombre;
    votos = params.data.info.vot;
    pvotos = params.data.info.pvot;
    hayInfo = params.data.info.mesas !== '0';
    hayEmpate = params.data.info.hayEmpate;
    hayGanador = params.data.info.hayGanador;
  } else {
    noSeCelebra = params.data.info;
  }

  return `
        <div style="max-width: 25rem; color: #333; padding: 0.5rem 1rem; font-size: 1.3rem; box-shadow:1px 1px 7px 0px rgba(0, 0, 0, 0.3); border-radius:2px; font-family: 'Raleway', 'Open Sans', 'Calibri', 'Georgia', 'Helvetica', 'sans-serif';">
        <div style='text-transform: uppercase; font-weight: ${
          esCapital ? 'bold' : '900'
        };'>${ambito}</div>
        ${
          // eslint-disable-next-line no-nested-ternary
          esCapital
            ? ``
            : noSeCelebra
            ? `<div>${noSeCelebra}</div>`
            : !hayInfo
            ? `<div>Sin información</div>`
            : votos == 0 && !hayEmpate && hayGanador
            ? ``
            : `<div style='overflow-x: hidden; text-overflow: ellipsis; text-transform: uppercase;}'><span>${
                hayEmpate ? 'Empate' : hayGanador ? camara : 'No Hay Ganador'
              }</span></div>
             <div>${pvotos + ' (' + fmt(votos) + ' votos)'}</div>`
        }
        </div>`;
};
export default tooltipMapa;
